import type { Schemas } from "@platform/contracts/client";
import { localName } from "@platform/ui/features";
import { locale } from "./i18n";

export type OpsCategory = Schemas["OpsCategory"];
export type ProductDraft = Schemas["ProductDraft"];
export type RiskEntry = Schemas["RiskEntry"];
export type RiskListEntry = Schemas["RiskListEntry"];
export type RiskMatch = Schemas["RiskMatch"];

/** A category named with its branches, such as "Valves › Gate valves", in the operator's language. */
export function categoryPath(categories: readonly OpsCategory[], id: string): string {
  const byId = new Map(categories.map((category) => [category.id, category]));
  const names: string[] = [];
  for (
    let current = byId.get(id);
    current !== undefined;
    current = current.parentId === null ? undefined : byId.get(current.parentId)
  ) {
    names.unshift(localName(current.name, locale));
    if (names.length > 20) break;
  }
  return names.join(" › ");
}

/** The categories in tree order with their depth, for indented lists. */
export function treeOrder(categories: readonly OpsCategory[]): { category: OpsCategory; depth: number }[] {
  const below = (parentId: string | null, depth: number): { category: OpsCategory; depth: number }[] =>
    categories
      .filter((category) => category.parentId === parentId)
      .sort((a, b) => a.sortOrder - b.sortOrder || a.slug.localeCompare(b.slug))
      .flatMap((category) => [{ category, depth }, ...below(category.id, depth + 1)]);
  return below(null, 0);
}
